import { constantRoutes } from '@/router';

const state = {
  routes: constantRoutes,
};

export default {
  namespaced: true,
  state,
};
